import { BaseBreadcrumbs } from "@cmde/shadcn";
import { Link, useLocation } from "react-router";
import type { IBreadcrumbItem } from "@cmde/shadcn";

export function AppBreadcrumbs({ breadcrumbs }: { breadcrumbs: IBreadcrumbItem[] }) {
  const { pathname } = useLocation();

  return (
    <BaseBreadcrumbs
      breadcrumbs={breadcrumbs}
      currentPath={pathname}
      renderLink={(href, children) => <Link to={href}>{children}</Link>}
    />
  );
}
